module.exports = __webpack_public_path__ + "img/tool-539.197c7a3.jpg";